import React from 'react';
import ReactModal from '../../components/Modal';
import { withTranslation } from 'react-i18next';

class BuyMoreEntitiesModal extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <ReactModal modalState={this.props.isOpen} className="width-sm">
                    <p>
                        {t('purchase_add_ons.modal.message_1')}{' '}
                        <strong>{this.props.entityCount}</strong>{' '}
                        {t('purchase_add_ons.modal.message_2', {
                            object_message: this.props.object_message,
                        })}{' '}
                        <strong>${this.props.totalPrice}</strong> {this.props.period}.
                    </p>
                    <div className="btn-wrapper">
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            {t('purchase_add_ons.modal.cancel')}
                        </button>
                        <button
                            onClick={this.props.onSubmit}
                            className="button button-filled button-primary width-sm btn"
                        >
                            {t('purchase_add_ons.modal.continue')}
                        </button>
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(BuyMoreEntitiesModal);
